<div
  class="form-group mb-0 d-flex align-items-center filter-input__container bootstrap-validation-background--hidden"
  #container
  [class]="{ 'mb-3': hasError, 'has-properties': hasProperties }"
>
  <div class="input-group">
    <ng-select
      class="filter-input"
      id="filter"
      #filter
      #firstLevel="tippy"
      [arrow]="false"
      [class]="{
        'filter-input--big-on-focus': hasProperties,
        'form-control--focused': firstLevel.isVisible,
        'is-invalid': hasError,
      }"
      [compareWith]="compare"
      [distance]="0"
      [isOpen]="false"
      [items]="tags"
      [keyDownFn]="handleKeyDown"
      [multiple]="true"
      [ngModel]="tags"
      [placeholder]="'common.filterInput.placeholder' | translate"
      [popover]="true"
      [portalTippy]="firstLevelTemplate"
      [tippyDisabled]="hasProperties === false"
      (blur)="handleBlur()"
      (clear)="clearFilter()"
      (focus)="handleFocus()"
      (hidden)="reset()"
      (remove)="handleTagRemoved($event.value)"
      (search)="handleInput($event)"
      appendTo="body"
      bindLabel="label"
      bindValue="key"
      placement="bottom-end"
      style="width: 200px"
      trigger="manual"
    >
      <ng-template let-clear="clear" let-item="item" ng-label-tmp>
        <span class="filter-input__tag-key">{{ property(item.value.key)?.label | translate }}</span>

        <span class="filter-input__tag-value">{{ label(item.value.arguments) }}</span>

        <span class="filter-input__tag-clear" (click)="clear(item)">
          <i class="far fa-times"></i>
        </span>
      </ng-template>
    </ng-select>

    @let isOpen = firstLevel.isVisible || metaList.isActive();

    @if (hasProperties) {
      <button
        class="btn filter-input__appended-button"
        id="filter-toggle"
        [class]="{
          'btn-outline-secondary': isOpen === false,
          'btn-secondary': isOpen,
        }"
        [portalTippy]="'common.filterInput.button.tooltip' | translate"
        (click)="handleFilterButtonClick()"
        placement="top"
        type="button"
      >
        <i class="far fa-filter"></i>
      </button>
    }

    @if (hasError) {
      <div class="filter-input__invalid-feedback invalid-feedback">{{ error }}</div>
    }
  </div>
</div>

<ng-template #firstLevelTemplate>
  <div
    class="filter-input__first-level"
    #secondLevel="tippy"
    [arrow]="false"
    [distance]="0"
    [popover]="true"
    [portalTippy]="secondLevelTemplate"
    (triggered)="handleFirstLevelTriggered()"
    placement="left-start"
    trigger="manual"
  >
    @for (entry of firstLevelList.entries; track entry; let index = $index) {
      <div
        class="dropdown-item g-no-user-select"
        [ngClass]="{
          'dropdown-item--highlight': index === firstLevelList.highlightedIndex,
          'dropdown-item--selected': index === firstLevelList.activeIndex,
        }"
        (mousedown.stop)="handleFirstLevelMouseEnter(entry)"
        (mouseenter)="handleFirstLevelMouseEnter(entry)"
        role="button"
      >
        <!-- Amount of active properties -->
        @if (entry.activeFilters > 0) {
          <span>
            <i class="far fa-check"></i>
          </span>
        }
        <!-- Label -->
        <span>{{ entry.label | translate }}</span>
        <span class="dropdown-item__indicator">
          <i class="far fa-angle-right"></i>
        </span>
      </div>
    }
  </div>
</ng-template>

<ng-template #secondLevelTemplate>
  <div class="filter-input__second-level" (click)="focusInput()">
    <div class="dropdown-header font-sm filter-input__second-level-header">
      <button
        class="btn btn-link filter-input__second-level-back d-block d-md-none"
        (click)="secondLevel.hide()"
      >
        <i class="far fa-angle-left"></i>

        {{ firstLevelList.highlighted?.label | translate }}
      </button>

      <span class="filter-input__second-level-back d-none d-md-block">
        {{ firstLevelList.highlighted?.label | translate }}
      </span>
    </div>

    @for (entry of secondLevelList.entries$ | async; track entry; let index = $index) {
      <div
        class="dropdown-item p-0"
        [ngClass]="{
          'dropdown-item--highlight': index === secondLevelList.highlightedIndex,
        }"
        (mouseenter)="handleSecondLevelMouseEnter(entry)"
      >
        <!-- label -->
        <div class="form-check ps-0">
          <label class="form-check-label filter-input__second-level-label" [for]="'label--' + index">
            <input
              class="form-check-input"
              [checked]="isActive(entry)"
              [id]="'label--' + index"
              (change)="toggleEntry(entry.key)"
              type="checkbox"
            />
            <!-- Label -->
            <span class="filter-input__second-level-description">{{ entry.label | translate }}</span>
            <!-- Amount of values that have the property -->
            <span
              class="badge ms-2"
              [ngClass]="{
                'text-bg-dark': entry.value.count > 0,
                'text-bg-light': entry.value.count == 0,
              }"
              >{{ entry.value.count }}</span
            >
          </label>
        </div>
      </div>
    }
  </div>
</ng-template>
